import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './routes'
import './index.css'

// When a lazy chunk 404s after a deploy (server returns HTML instead of JS),
// the import() rejects with a SyntaxError. Hard-reload once to fetch fresh chunks.
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const msg = event?.reason?.message ?? '';
    if (msg.includes('<!DOCTYPE') || msg.includes('is not valid JSON') || msg.includes('Failed to fetch dynamically imported module') || msg.includes('Unexpected token')) {
      const reloadKey = '_chunk_reload';
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, '1');
        window.location.reload();
      }
    }
  });
}

// The router object receives global Layout internally from `routes.tsx` configuration!
export const createRoot = ViteReactSSG({ routes });
